// extracted by mini-css-extract-plugin
export default {"item__img":"Network_item__img__2NkCx","item__btn":"Network_item__btn__BhdRn"};